const modalContainer = document.querySelector(".tangent-modal-overlay"),
    modalClosebtn = document.querySelector(".modal-close-btn"),
    productBlock = document.querySelector(".product-block"),
    quizContainer = document.querySelector("#tangent-main-container"),
    productContainer = document.querySelector(".product-recommendation-container");
modalClosebtn.addEventListener("click", () => {
    handleModalClose();
});
const handleModalClose = () => {
    modalContainer.style.display = "none";
};
window.addEventListener("quiz_submit", (e) => {
    TangentAi.init(e.detail);
});
const TangentAi = (function () {
    const init = (resp_id) => {
            fetchRecommendation(resp_id)
                .then((recommendationData) => displayRecommendation(recommendationData))
                .catch((e) => console.log(e));
        },
        fetchRecommendation = async (resp_id) => {
            try {
                let response = await fetch(
                    `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${resp_id}&self_serve=true&multiple_variants=true`
                );
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return await response.json();
            } catch (error) {
                return console.error("Error fetching data:", error), null;
            }
        },
        renderProducts = (products) => {
            const productHtml = `<img class="product-image" src="${products[0].variantImage}"/>
            <p class="product-title">${products[0].title} - ${products[0].variantTitle}</p>
            <button class="product-add-to-cart-button" id='${products[0].variantId}' onclick='handleModalClose()' >Close</button>`;
            productBlock.innerHTML = productHtml;
        },
        displayRecommendation = (data) => {
            let recommendedProducts = getRecommendedProductDetails(data.selected_variants, data.products);
            console.log(recommendedProducts, "recommend product"),
                (quizContainer.style.display = "none"),
                (productContainer.style.display = "block"),
                renderProducts(recommendedProducts);
        },
        addVariantToCart = (variantId) => {
            console.log(variantId, "variant id"),
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: "4788715746" }] }),
                })
                    .then((res) => {
                        let addToCartBtn = document.querySelector(".product-add-to-cart-button");
                        (addToCartBtn.innerText = "Added to cart"),
                            addToCartBtn.setAttribute("disabled", !0),
                            console.log(res, "response cart");
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
        },
        getSelectedVariantsObject = (individualProducts, selectedVaraints) => {
            const filteredObject = {};
            return (
                individualProducts.forEach((productId) => {
                    selectedVaraints.hasOwnProperty(productId) &&
                        (filteredObject[productId] = selectedVaraints[productId]);
                }),
                filteredObject
            );
        },
        getRecommendedProductDetails = (selectedVariants, productList) => {
            let resultedProducts = [];
            for (let productId in selectedVariants)
                if (selectedVariants[productId].length > 0) {
                    let matchingProduct = filterList(productList, productId);
                    if ((console.log(matchingProduct, "matching product"), matchingProduct))
                        for (let variantId of selectedVariants[productId]) {
                            let matchingVariant = filterList(matchingProduct.variants, variantId);
                            if (matchingVariant) {
                                let productDetails = {
                                    title: matchingProduct.title,
                                    handle: matchingProduct.handle,
                                    productId: matchingProduct.id,
                                    variantId: matchingVariant.id,
                                    variantTitle: matchingVariant.title,
                                    variantImage: getVariantImage(matchingVariant.image_id, matchingProduct),
                                    price: matchingVariant.price,
                                    isVariantAvailable: isVariantAvalaible(matchingProduct, matchingVariant),
                                    imageAlt: "Variant image",
                                };
                                resultedProducts.push(productDetails);
                            }
                        }
                }
            return resultedProducts;
        },
        filterList = (lists, matchingId) => (
            console.log(lists, "lists", matchingId, "matchingId"),
            lists.find((list) => (list.id || list.node?.id.split("/").pop()) == matchingId)
        ),
        isVariantAvalaible = (product, variant) =>
            product.status == "ARCHIVED"
                ? !1
                : variant.inventoryQuantity > 0 || variant.inventory_policy.toLowerCase() === "continue",
        getVariantImage = (imageId, product) =>
            imageId ? product.images.find((image) => image.id == imageId).src : product.image.src;
    return { init, addVariantToCart };
})();
